import { getDomainEnvironment } from '@/domains/core/platform/domains/getDomainEnvironment';

import type { RawTracking, RawTrackingStep } from './interfaces/Transaction';

export function getCdnURL(): string {
  // warning: this is a temporay fix.
  // It's the responsibility of the ms API to return the correct path
  return `https://cdn.${getDomainEnvironment()}manomano.com`;
}

export function getLastTracklineStep(
  tracking: RawTracking,
): RawTrackingStep | undefined {
  if (tracking.steps.length === 0) return undefined;

  return tracking.steps.reduce((a, c) => {
    if (
      c.label.includes('delivered') &&
      c.segments &&
      c.current &&
      c.segments !== c.current
    )
      return a;
    return c.current && c.current > 0 ? c : a;
  });
}

export function formatQueryParamOrderId(
  orderId: string | string[] | undefined,
): number | undefined {
  return typeof orderId === 'string' ? Number(orderId) : undefined;
}

export type SnakeToCamelCase<S extends string | number | symbol> =
  S extends `${infer T}_${infer U}`
    ? `${T}${Capitalize<SnakeToCamelCase<U>>}`
    : S;
